import PassCover from 'icons/pass-cover'
import PassLogo from 'icons/pass-logo'
import React from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { invertTextColor } from 'utils'

function ApplePass({ design, pass }) {
  const { backgroundColor, logoImage, stripImage, fullName, points, passCode } =
    design

  const isEnglish = (text) => {
    if (typeof text !== 'string') return true
    const cleanText = text.replace(/\s+/g, '').toLowerCase()
    return /[a-zA-Z]/g.test(cleanText)
  }

  return (
    <div className='tw-relative' style={{ maxWidth: '330px' }}>
      <div
        className='tw-visible tw-w-[330px] tw-shadow-lg tw-text-white tw-rounded-2xl'
        style={{ backgroundColor }}
      >
        <div className='tw-flex tw-flex-col tw-h-full tw-justify-between tw-pb-6'>
          <div className='tw-mt-3 tw-ml-3 tw-w-1/6'>
            {logoImage ? (
              <img class='even:tw-hidden' src={logoImage} alt='Logo'></img>
            ) : (
              <div id='default-logo' className='tw-block tw-mt-3 tw-ml-3 '>
                <PassLogo color={invertTextColor(backgroundColor)} />
              </div>
            )}
          </div>
          <div className='tw-items-center tw-justify-center tw-overflow-hidden tw-flex tw-h-[220px] tw-my-0'>
            {stripImage ? (
              <div
                className='tw-block tw-w-full tw-h-full tw-bg-cover tw-bg-center'
                style={{ backgroundImage: `url(${stripImage})` }}
              />
            ) : (
              <span
                id='default-strip'
                className='tw-flex tw-items-center tw-px-6 tw-w-full  tw-aspect-[3/1]'
              >
                <div className='tw-mx-auto tw-w-2/3'>
                  <PassCover color={invertTextColor(backgroundColor)} />
                </div>
              </span>
            )}
          </div>
          <div className='tw-mb-6 tw-mt-4'>
            <div className='tw-px-6'>
              <p
                className='tw-flex tw-justify-between tw-text-xs tw-uppercase tw-opacity-80 tw-font-semibold'
                style={{
                  color: invertTextColor(backgroundColor),
                  textAlign: isEnglish(fullName) ? 'left' : 'right',
                }}
              >
                <span>Customer Name</span>
                <span>Points</span>
              </p>
              <p
                className='tw-flex tw-justify-between tw-text-lg tw-font-bold tw-mt-0.5'
                style={{
                  color: invertTextColor(backgroundColor),
                  textAlign: isEnglish(fullName) ? 'left' : 'right',
                }}
              >
                <span>{fullName}</span>
                <span>{points || 0}</span>
              </p>
            </div>
          </div>
          <div className='tw-bg-white tw-mx-auto tw-rounded-md tw-card-qrcode tw-max-w-[138px] tw-p-[5px]'>
            <QRCodeCanvas
              value={passCode}
              title={passCode}
              viewBox='0 0 53 53'
              size={128}
            />
            {/* <p className=' tw-mt-1 tw-font-extralight tw-text-black tw-text-center tw-text-sm'> {passCode} </p> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ApplePass
